export const SEARCH_DATE_RANGE_PICKER_OPEN = "search_date_range_picker_open";
export const ROUTES_PAGE_INIT_LOADDATA = "routes_page_init_loadData";
export const ROUTES_PAGE_CHANGE_CABIN = "routes_page_change_cabin";
export const ROUTES_PAGE_CHANGE_CONDITION = "routes_page_change_condition";
export const ALL_ROUTES_PAGE_CHANGE_CONDITION = "all_routes_page_change_condition";
export const ROUTES_PAGE_CHANGE_KEYWORDS = "hotel_page_change_keywords";
export const DATA_FAST_FORWARD = "data_fast_forward";
export const FLIGHT_DATA_FAST_FORWARD = "flight_data_fast_forward";
export const TOOLS_AIRLINE_FINDER = "tools_airline_finder";
export const CREDIT_CARD_PAGE_CHANGE_KEYWORDS = "credit_card_page_change_keywords";

export const ROUTES_PAGE_CHANGE_PROGRAM = "routes_page_change_program";
export const DEAL_ROUTES_PAGE_CHANGE_PROGRAM = "deal_routes_page_change_program";
export const FLIGHT_PAGE_CHANGE_FILTER = "flight_page_change_filter";
